module.exports = __webpack_public_path__ + "img/线对齐-角标2.2f02ad11.svg";